export const LOG_TYPE_CLIENT = {
  EVENT: "event",
  ERROR: "error",
  EMAIL: "email",
};

export const LOG_CATEGORY_CLIENT = {
  USER: "user",
  UNAUTH: "unauth",
}

export const USER_LOGS_CLIENT = {
  //   common
  TRACKING_EVENT_FAILED: {
    message: "Tracking event failed.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  // Events
  LEARNER_REGISTRATION_SUCCESS: {
    message: "Learner account created successfully.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EVENT,
  },
  ACCOUNT_NAME_UPDATE_FAILED: {
    message: "Account name update failed.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  ACCOUNT_NUMBER_UPDATE_FAILED: {
    message: "Failed to update account number.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR
  },
  ACCOUNT_PASSWORD_UPDATE_FAILED: {
    message: "Failed to update account password.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR
  },
  ACCOUNT_PASSWORD_UPDATE_SUCCESS: {
    message: "Account password updated successfully.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EVENT,
  },
  EMAIL_VERIFICATION_SUCCESS: {
    message: "Email verification successful.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EMAIL,
  },
  EMAIL_VERIFICATION_RESEND_SUCCESS: {
    message: "Email verification resent successfully.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EMAIL,
  },
  CLASSROOM_ENTERED: {
    message: "Learner entered the classroom.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EVENT,
  },
  CLASS_SCHEDULE_UPDATE_SUCCESS: {
    message: "Class schedule updated successfully.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EVENT,
  },
  EDUCATOR_ROOM_ENTERED: {
    message: "Educator entered the room.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EVENT,
  },
  CONFERENCE_ROOM_FETCH_FAILED: {
    message: "Failed to fetch conference room data.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  BASICS_STEP_UPDATE_SUCCESS: {
    message: "Basic step update success",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.EVENT,
  },

  // Errors
  EMAIL_VERIFICATION_FAILED: {
    message: "Email verification failed.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  SIGN_IN_FAILED: {
    message: "Sign in with custom token failed.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  USER_DATA_NOT_FOUND: {
    message: "User data not found in database.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  COURSE_CLASS_NOT_FOUND: {
    message: "Course or class not found.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CHECKOUT_STATE_MISSING: {
    message: "Checkout state is missing (course id, class id, educator id).",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CHECKOUT_NOT_AVAILABLE: {
    message: "Checkout is not available right now.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  SERVER_TIME_NOT_RETRIEVED: {
    message: "Server time could not be retrieved.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  PAGE_NOTE_FOUND_ERROR: {
    message: "Page not found function throws error",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  COURSE_URL_NOT_AVAILABLE: {
    message: "Course URL is not available.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CLASS_EXPIRED: {
    message: "Class has expired and cannot be enrolled.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EMAIL_VERIFICATION_RESEND_FAILED: {
    message: "Failed to resend email verification.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EMAIL_VERIFICATION_CHECK_FAILED: {
    message: "Failed to check email verification status.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  SERVER_TIME_FETCH_FAILED: {
    message: "Failed to fetch server time",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CLASS_SCHEDULE_UPDATE_FAILED: {
    message: "Failed to update class schedule.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  REFUND_ERROR: {
    message: "An unexpected error occurred during the refund process",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  GET_ALL_REFUNDS_ERROR: {
    message: "Something went wrong while getting learner stripe refunds",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  GET_ALL_PURCHASES_ERROR: {
    message: "Something went wrong while getting learner purchase history.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CONTACT_FORM_SUBMISSION_FAILED: {
    message: "Contact form submission failed.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  BASICS_STEP_UPDATE_FAILED: {
    message: "Failed to update basics step.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EXPERIENCE_STEP_UPDATE_FAILED: {
    message: "Failed to update experience step.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CLASS_SCHEDULE_STEP_DECREMENT_FAILED: {
    message: "Failed to decrement class schedule step.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  COURSE_DETAILS_STEP_UPDATE_FAILED: {
    message: "Failed to update course details step.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  COURSE_DETAILS_STEP_DECREMENT_FAILED: {
    message: "Failed to decrement course details step.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CURRICULUM_UPDATE_FAILED: {
    message: "Failed to update curriculum.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CURRICULUM_STEP_DECREMENT_FAILED: {
    message: "Failed to decrement curriculum step.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  COURSE_NOT_FOUND: {
    message: "Course not found.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EARNINGS_STRIPE_CONNECT_FAILED: {
    message: "Failed to connect Stripe account.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EARNINGS_BALANCE_FETCH_FAILED: {
    message: "Failed to fetch earnings balance.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EARNINGS_PAYMENTS_FETCH_FAILED: {
    message: "Failed to fetch earnings payments.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  STRIPE_SECRET_FETCH_FAILED: {
    message: "Failed to fetch Stripe secret.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  STRIPE_INITIALIZATION_FAILED: {
    message: "Failed to initialize Stripe.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  STEP_UPDATE_FAILED: {
    message: "Failed to update step.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  CUSTOM_TOKEN_SIGNIN_FAILED: {
    message: "custom token signin failed.",
    category: LOG_CATEGORY_CLIENT.USER,
    type: LOG_TYPE_CLIENT.ERROR,
  },
 
};

export const UNAUTH_LOGS_CLIENT = {
  // Events
  RESET_PASSWORD_EMAIL_SENT: {
    message: "Reset Password Email Sent",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.EVENT,
  },
  
  // Errors
  RESET_PASSWORD_ERROR: {
    message: "Reset Password Email is not Sent",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  TRACKING_EVENT_FAILED: {
    message: "Tracking event failed.",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  ADMIN_EMAIL_RESTRICTED: {
    message: "Admin email restricted from creating account.",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  ACCOUNT_CREATION_FAILED: {
    message: "Account creation failed.",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  UPDATING_USER_DATA_FAILED: {
    message: "Error updating user in Firebase",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  LOGIN_FAILED: {
    message: "User account is not login",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EDUCATOR_REGISTRATION_FAILED: {
    message: "Educator registration failed.",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  EDUCATOR_LOGIN_FAILED: {
    message: "Educator login failed.",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  },
  AMPLITUDE_ERROR: {
    message: "Error initializing Amplitude.",
    category: LOG_CATEGORY_CLIENT.UNAUTH,
    type: LOG_TYPE_CLIENT.ERROR,
  }
};